"use client";

import { Card } from "@/components/ui/card";
import { CalendarDays, Clock } from "lucide-react";
// @ts-ignore - Prisma client types
import type {  Protocol  } from '@prisma/client';

interface ProtocolListProps {
  protocols: Protocol[];
}

export const ProtocolList: React.FC<ProtocolListProps> = ({ protocols }) => {
  if (!protocols) {
    return (
      <div className="text-center text-muted-foreground mt-4">
        Loading protocols...
      </div>
    );
  }

  if (protocols.length === 0) {
    return (
      <div className="text-center text-muted-foreground mt-4">
        No protocols found. Create one to get started!
      </div>
    );
  }

  return (
    <div className="space-y-4 mt-4">
      {protocols?.map((protocol) => (
        <Card key={protocol.id} className="p-4 hover:shadow-md transition-shadow">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between items-start">
              <h3 className="text-lg font-semibold">{protocol.name}</h3>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Clock className="h-4 w-4" />
                <span className="capitalize">{protocol.frequency}</span>
              </div>
            </div>
            <p className="text-muted-foreground">{protocol.description}</p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground mt-2">
              <CalendarDays className="h-4 w-4" />
              <span>Created {new Date(protocol.createdAt).toLocaleDateString()}</span>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};